import { themeObject, validationsMessages } from 'lib';
import {
    Control,
    FieldErrors,
    UseFormClearErrors,
    UseFormSetValue,
    UseFormWatch,
} from 'react-hook-form';
import * as yup from 'yup';

// Any type will be handled later
export interface FieldNameTypeFormProps {
    control: Control<any>;
    errors: FieldErrors<any>;
    watch: UseFormWatch<any>;
    setValue: UseFormSetValue<any>;
    clearErrors: UseFormClearErrors<any>;
}

export const NONE = 'None';
export const CUSTOM = 'Custom';
export const FROM_DICTIONARY = 'From Dictionary';

export const fieldNameTypeOptions = [
    { value: NONE, label: NONE },
    { value: CUSTOM, label: CUSTOM },
    { value: FROM_DICTIONARY, label: FROM_DICTIONARY },
] as const;

export type FieldNameTypeOptions =
    (typeof fieldNameTypeOptions)[number]['value'];

export interface FieldNameTypeFormValues {
    fieldNameType: FieldNameTypeOptions | null;
    customFieldName?: string;
    dictionary?: string;
    fieldName?: string;
}

export const FieldNameTypeDefaults: FieldNameTypeFormValues = {
    fieldNameType: null,
    customFieldName: '',
    dictionary: '',
    fieldName: '',
};

export const FieldNameTypeSchema = yup.object({
    fieldNameType: yup
        .mixed<FieldNameTypeOptions>()
        .oneOf(fieldNameTypeOptions.map((o) => o.value))
        .required(validationsMessages.required),
    customFieldName: yup.string().when('fieldNameType', {
        is: 'Custom',
        then: (schema) => schema.required(validationsMessages.required),
        otherwise: (schema) => schema.notRequired().nullable(),
    }),
    dictionary: yup.string().when('fieldNameType', {
        is: 'From Dictionary',
        then: (schema) => schema.required(validationsMessages.required),
        otherwise: (schema) => schema.notRequired().nullable(),
    }),
    fieldName: yup.string().when('fieldNameType', {
        is: 'From Dictionary',
        then: (schema) => schema.required(validationsMessages.required),
        otherwise: (schema) => schema.notRequired().nullable(),
    }),
});

export const fieldNameTypeFormStyles = {
    formFieldHeight: {
        '& .MuiFormControl-root': {
            width: '100%',
            '& .MuiInputBase-root': {
                height: '38px',
            },
        },
    },
    fieldNameTypeOptionsList: {
        borderRadius: '12px',
        '& .MuiList-root': {
            '& .MuiMenuItem-root': {
                fontSize: '18px',
            },
            '& .Mui-focusVisible': {
                display: 'none',
            },
        },
    },
    customFieldNameContainerStyles: {
        width: '100%',
        mt: 1.5,
    },
    customFieldNameStyles: {
        mt: 0.5,
        width: 'calc(100% - 24px)',
        borderLeft: `4px solid ${themeObject.palette.primary.main}`,
        marginLeft: '6.41px',
        paddingLeft: '13.59px',
        '& .MuiFormControl-root': {
            width: '100%',
        },
    },
    stepOptionListConatiner: {
        maxHeight: '135px',
        overflowY: 'auto',
    },
    dictionarySelect: {
        width: '100%',
        '& .MuiSelect-icon': {
            color: themeObject.palette.primary.dark,
        },
        '& .MuiFormControl-root': {
            width: '100%',
            '& .MuiTextField-root': {
                '& .MuiInputBase-root': {
                    height: '38px',
                    pr: '50px',
                    '& .MuiInputBase-input': {
                        height: '100%',
                    },
                },
            },
        },
    },
};
